import { UtilityService } from './../services/utility.service';
import { SelectItem } from 'primeng/api';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'countryName',
})
export class CountryNamePipe implements PipeTransform {
  countryNames: SelectItem[];

  constructor(private utilityService: UtilityService) {
    this.countryNames = this.utilityService.getCountriesList();
  }

  /**
   * get the country code and return his suitable name.
   * @param value country code as a number
   * @param args
   * @returns the countryName
   */
  transform(value: number, ..._args: unknown[]): any {
    for (const i of this.countryNames) {
      if (i.value === value) {
        return i.label;
      }
    }
  }
}
